export default {
    state: {
        rk_refs: null,
    },

    getters: {
        rk_refs: state => state.rk_refs,
    },

    actions: {
        async getConfigData({ commit, dispatch }) {
            let r = await dispatch('doRequest', {
                endpoint: '/api/v3/rkref/getconfigdata',
                method: 'GET',
                body: null,
            })
            commit('commitData', r)
        },
    },

    mutations: {
        commitData(state, rk_refs) {
            state.rk_refs = { ...state.rk_refs, ...rk_refs }
        }
    }
}